import React, { Component } from 'react';

class Header extends Component {
    state = {  } 
    render() { 
        return (
            <div style={{ textAlign:"center", color:"#ffffff" }}>
            <h1>Amit |  👨‍💻</h1>    
          <h2>@amit_rakib / @mrahr</h2>
          <p style={{color:"#ffffff"}}>Here are some of the links to other platforms I'm really active at!</p>
            </div>
            
        );
    }
}
 
export default Header;